<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <strong>
                こちらの内容でVNコネクト設定を削除します。よろしいですか？
              </strong>
            </v-row>
            <div class="mt-3 ml-2">
              <v-row>
                <v-col cols="12">
                  <app-label-group label="サイト名">
                    <template #value>
                      <div class="ml-3">
                        {{ connect.enumber }}:{{
                          $filter.emptyTo(connect.siteName, "-")
                        }}
                        (<template v-if="connect.vlanIdType === 'SPECIFIED'">
                          {{ connect.vlanId }}
                        </template>
                        <template v-else>
                          {{
                            $filter.enumTo(connect.vlanIdType, "vlanIdType")
                          }} </template
                        >)
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="接続先仮想ネットワーク(VPN/VN)名"
                    :value="
                      connect.vnName
                        ? connect.vnName +
                          '(' +
                          connect.vpnVnCode +
                          ':' +
                          connect.vnType +
                          ')'
                        : connect.vpnVnCode
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="VNコネクト名"
                    :value="connect.vnConnectName"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="ペア回線"
                    :value="$filter.emptyTo(connect.pairLine, '-')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <app-label-group label="品目">
                    <template #value>
                      <div class="ml-3">
                        <template v-if="connect.bandwidthType === 'BURST'">
                          <template v-if="lineBandwidth">
                            バースト
                            <template
                              v-if="lineBandwidth.bandwidthType === 'BURST10'"
                              >(バースト10)</template
                            >
                            <template
                              v-else-if="
                                lineBandwidth.bandwidthType === 'BURST100'
                              "
                              >(バースト100)</template
                            >
                          </template>
                          <template v-else>バースト</template>
                        </template>
                        <template v-else>
                          {{
                            $filter.enumTo(
                              connect.bandwidthType,
                              "vnConBandwidthType"
                            )
                          }}
                          <template v-if="connect.bandwidth">
                            ({{ connect.bandwidth.value
                            }}{{
                              $filter.enumTo(
                                connect.bandwidth.unit,
                                "bandwidth_unit"
                              )
                            }})
                          </template>
                        </template>
                      </div>
                    </template>
                  </app-label-group>
                </v-col>
              </v-row>

              <div v-if="connect.vnType === 'L3'">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="ルーティング種別"
                      :value="connect.l3!.bgp4 !== null ? 'BGP4' : 'Static'"
                    />
                  </v-col>
                </v-row>
              </div>

              <div v-if="connect.vnType === 'L2'">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="VLAN制御"
                      :value="
                        $filter.enumTo(connect.l2!.isVlanControl, 'on_off')
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="QoS設定"
                      :value="
                        connect.qos
                          ? $filter.enumTo(connect.qos.isQoS, 'on_off')
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="割当帯域パターン"
                      :value="
                        connect.qos
                          ? $filter.enumTo(
                              connect.qos.qosBandControlPattern,
                              'vnConControlPattern'
                            )
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>
              </div>

              <div v-if="connect.vnType === 'L3' && connect.l3">
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="WANアドレス"
                      :value="connect.l3.wanAddress"
                    />
                  </v-col>
                </v-row>
                <div v-if="connect.l3.bgp4 !== null">
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="ピアIPアドレス"
                        :value="connect.l3.bgp4.peerIpAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="AS番号"
                        :value="connect.l3.bgp4.asNumber"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="MD5キー"
                        :value="$filter.emptyTo(connect.l3.bgp4.md5Key, '-')"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="Maximum Prefix"
                        :value="connect.l3.bgp4.maximumPrefix"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="Local Preference"
                        :value="
                          $filter.enumTo(
                            connect.l3.bgp4.localPreference,
                            'localPreference'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="MED"
                        :value="$filter.enumTo(connect.l3.bgp4.med, 'med')"
                      />
                    </v-col>
                  </v-row>
                </div>
                <!-- 経路設定 -->
                <div v-else>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group label="経路設定" />
                    </v-col>
                  </v-row>
                  <v-row class="ml-2">
                    <v-col cols="6">
                      <app-label-group label="LANアドレス">
                        <template #value>
                          <div class="ml-3">
                            <template
                              v-if="sortedStaticLanAddressList.length !== 0"
                            >
                              <div
                                v-for="(e, index) in sortedStaticLanAddressList"
                                :key="index"
                              >
                                {{ $filter.emptyTo(e.lanAddress, "-") }}
                              </div>
                            </template>
                            <template v-else>-</template>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                    <v-col cols="6">
                      <app-label-group label="ネクストホップアドレス">
                        <template #value>
                          <div class="ml-3">
                            <template
                              v-if="sortedStaticLanAddressList.length !== 0"
                            >
                              <div
                                v-for="(e, index) in sortedStaticLanAddressList"
                                :key="index"
                              >
                                {{ $filter.emptyTo(e.nextHopAddress, "-") }}
                              </div>
                            </template>
                            <template v-else>-</template>
                          </div>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                </div>

                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="QoS設定"
                      :value="
                        connect.qos
                          ? $filter.enumTo(connect.qos.isQoS, 'on_off')
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="割当帯域パターン"
                      :value="
                        connect.qos
                          ? $filter.enumTo(
                              connect.qos.qosBandControlPattern,
                              'vnConControlPattern'
                            )
                          : '-'
                      "
                    />
                  </v-col>
                </v-row>

                <div v-if="connect.l3.bgp4 !== null">
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="経路集約"
                        :value="connect.l3.bgp4.routeAggregation"
                      />
                    </v-col>
                  </v-row>
                  <v-row v-if="connect.l3.bgp4.routeAggregation !== 'OFF'">
                    <v-col cols="12">
                      <app-label-group label="経路集約アドレス">
                        <template #value>
                          <template
                            v-if="connect.l3.bgp4.routeAggregation === 'CUSTOM'"
                          >
                            <div class="d-flex flex-wrap">
                              <span
                                class="ml-3"
                                v-for="(e, index) in connect.l3.bgp4
                                  .routeAggregationAddressList"
                                :key="index"
                              >
                                {{ e }}
                              </span>
                            </div>
                          </template>
                          <template
                            v-else-if="
                              connect.l3.bgp4.routeAggregation === 'ON'
                            "
                          >
                            <span class="pl-3">0.0.0.0/0</span>
                          </template>
                        </template>
                      </app-label-group>
                    </v-col>
                  </v-row>
                </div>

                <!-- DHCPリレー -->
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="DHCPリレー"
                      :value="connect.l3.dhcpRelay ? 'ON' : 'OFF'"
                    />
                  </v-col>
                </v-row>

                <template v-if="connect.l3.dhcpRelay">
                  <v-row>
                    <v-col v-if="connect.l3.dhcpRelay" cols="12">
                      <app-label-group
                        label="プライマリサーバ"
                        :value="connect.l3.dhcpRelay.primaryAddress"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <app-label-group
                        label="セカンダリサーバ"
                        :value="
                          $filter.emptyTo(
                            connect.l3.dhcpRelay.secondaryAddress,
                            '-'
                          )
                        "
                      />
                    </v-col>
                  </v-row>
                </template>
              </div>

              <v-row>
                <v-col cols="12">
                  <app-label-group
                    label="備考"
                    :value="$filter.emptyTo(connect.description, '-')"
                  />
                </v-col>
              </v-row>
            </div>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="ok" variant="flat" color="primary">はい</v-btn>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >いいえ</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { VNConnectDetail } from "@/apis/VNConnectApi";
import type { BandwidthListGetEntity } from "@/apis/AccessLineApi";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "VNConnectDeleteConfirm",
  props: {
    wnumber: {
      type: String as PropType<string>,
      required: true,
    },
    connect: {
      type: Object as PropType<VNConnectDetail>,
      required: true,
    },
    /** 回線契約状況、回線種別によっては存在しないのでその場合はなし */
    lineBandwidth: {
      type: Object as PropType<BandwidthListGetEntity>,
      required: false,
    },
  },
  computed: {
    sortedStaticLanAddressList(): {
      lanAddress: string;
      nextHopAddress: string;
    }[] {
      const list = this.connect?.l3?.static ?? [];
      return [...list].sort((a, b) =>
        sortCompare(a, b, [["lanAddress", "asc"]])
      );
    },
  },
});
</script>
